import AgoraRTC from 'agora-rtc-sdk'
var localStream;
var client =  AgoraRTC.createClient({mode: 'rtc', codec: "h264"});
//var videoStream =  AgoraRTC.createClient({mode: 'live', codec: "h264"});

export const startTheCall = function (camera, microphone, user_id, host) {
    var channel_key = null;
    var streamId = '';
    
    
    function join(){
        return client.join(channel_key, 'black_answer_private_channel', null, function(uid) {
            console.log("User " + uid + " join channel successfully");    
              localStream = AgoraRTC.createStream({
                  streamID: user_id, 
                  audio: true, 
                  cameraId: camera, 
                  microphoneId: microphone, 
                  video: !host, 
                  screen: false}
                );
                localStream.init(function() {
                    console.log("getUserMedia successfully");
                    //if (host) localStream.play('agora_local');
                
                    client.publish(localStream, function (err) {
                      console.log("Publish local stream error: " + err);
                    });
                
                    client.on('stream-published', function (evt) {
                      console.log("Publish local stream successfully");
                    });
                  }, function (err) {
                    console.log("getUserMedia failed", err);
                });
    
                // The user has granted access to the camera and mic.
                localStream.on("accessAllowed", function() {
                    console.log("accessAllowed");
                });
                
                // The user has denied access to the camera and mic.
                localStream.on("accessDenied", function() {
                    console.log("accessDenied");
                });
        
        }, function(err) {
            console.log("Join channel failed", err);
          });
    }
    
    if(!AgoraRTC.checkSystemRequirements()) {
       alert("Your browser does not support WebRTC!");
       return;
    }
    
    client.init('45cab9521e694d3bba827644518aa9f4', function () {
        console.log("AgoraRTC client initialized");
        streamId = join()
     }, function (err) {
        console.log("AgoraRTC client init failed", err);
    });


    client.on('error', function(err) {
        console.log("Got error msg:", err.reason);
        if (err.reason === 'DYNAMIC_KEY_TIMEOUT') {
            client.renewChannelKey(channel_key, function(){
            console.log("Renew channel key successfully");
            }, function(err){
            console.log("Renew channel key failed: ", err);
            });
        }
    });

    client.on('stream-added', function (evt) {
        var stream = evt.stream;
        console.log("New stream added: " + stream.getId());
        console.log("Subscribe ", stream);
        client.subscribe(stream, function (err) {
            console.log("Subscribe stream failed", err);
        });
    });
    
    client.on('stream-subscribed', function (evt) {
        var stream = evt.stream;
        console.log("Subscribe remote stream successfully: " + stream.getId());
        stream.play('agora_local');
      });
    
    client.on('stream-removed', function (evt) {
        var stream = evt.stream;
        if (stream.isPlaying()) stream.stop();
        console.log("Remote stream is removed " + stream.getId());
    });
      
    client.on('peer-leave', function (evt) {
        var stream = evt.stream;
        if (stream) {
          if (stream.isPlaying()) stream.stop();
          console.log(evt.uid + " leaved from this channel");
        }
    });
    
      function leave() {
        client.leave(function () {
          console.log("Leavel channel successfully");
        }, function (err) {
          console.log("Leave channel failed");
        });
      }
    
    function publish() {
        client.publish(localStream, function (err) {
          console.log("Publish local stream error: " + err);
        });
    }
    
    function unpublish() {
        client.unpublish(localStream, function (err) {
          console.log("Unpublish local stream failed" + err);
        });
    }
}

export const closeTheCall = (user_id) =>{
  if (client){
    client.unpublish(localStream, function (err) {
      console.log("Unpublish local stream failed" + err);
    });
   client.leave(function () {
      console.log("Leave channel from "+ user_id + "successfully");
      if (localStream && localStream.isPlaying() ){
           localStream.stop();
      }
      if (localStream)  localStream.close();  
    }, function (err) {
      console.log("Leave channel from "+ user_id + "failed");
    });
  }
}
  

  














// WEBPACK FOOTER //
// ./src/utils/CallSystem.js